import { Button, Row } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useRef } from 'react';

export default function BookcaseSection(p: { title: string; children: any }) {
  const rowRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <h2 className="Library-section-title">{p.title}</h2>

      <div className="Library-section-container">
        <Button
          type="link"
          icon={<LeftOutlined />}
          onClick={() => {
            rowRef.current?.scrollTo({ left: rowRef.current.scrollLeft - 120, behavior: 'smooth' });
          }}
          className="Action-button Library-section-left-button"
        />
        <Row
          ref={rowRef}
          wrap={false}
          onWheel={(e) => {
            if (e.deltaY === 0) return;
            e.preventDefault();
            rowRef.current?.scrollTo({ left: rowRef.current.scrollLeft + e.deltaY });
          }}
          className="Library-section"
        >
          {p.children}
        </Row>
        <Button
          type="link"
          icon={<RightOutlined />}
          onClick={() => {
            rowRef.current?.scrollTo({ left: rowRef.current.scrollLeft + 120, behavior: 'smooth' });
          }}
          className="Action-button Library-section-right-button"
        />
      </div>
    </>
  );
}
